import { Button } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";

interface CallToActionButtonProps {
  buttonText: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  IconComponent: React.ElementType;
  isDisabled?: boolean;
  classes?: string;
}

export function CallToActionButton(props: CallToActionButtonProps) {
  const { IconComponent, buttonText, onClick, classes, isDisabled } = props;

  // Regular expression to check for 'text-{color}' classes
  // This pattern matches 'text-' followed by a color name,
  // which may include a hyphen and a number for shades (like red-500)
  const textColorClassPattern = /text-([a-z]+(-\d+)?)/;
  const hasTextColorClass = textColorClassPattern.test(classes || "");

  return (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      variant="contained"
      className={`flex xl:justify-between h-[30px] gap-2 py-1 px-8 text-xl ${
        !hasTextColorClass ? "text-white" : ""
      } rounded ${classes}`}
      sx={{
        "&.Mui-disabled": {
          backgroundColor: "#eaeaea!important",
          color: "#c0c0c0",
        },
      }}
    >
      {buttonText && (
        <Typography variant="subtitle" noWrap className="max-md:hidden leading-[24px]">
          {buttonText}
        </Typography>
      )}
      <IconComponent fontSize="small" />
    </Button>
  );
}
